import { combineReducers } from 'redux';

import processing from './processing/reducer';

export default combineReducers({
  processing,
});



// WEBPACK FOOTER //
// ./src/pages/cepbulkprocessing/state/reducer.js